/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { useSelector } from 'react-redux';

import { Checkbox } from '../../../../../components/common';
import { useSubscriberIdContext } from '../../../context';
import { dcRuleNotificationSelector, dcRulesTranslationSelector } from '../selectors';

const SubscriberIdDcRuleNotifications = () => {

    const { subscriberId } = useSubscriberIdContext();

    const { notification: tNotification } = useSelector(dcRulesTranslationSelector());
    const notification = useSelector(dcRuleNotificationSelector(subscriberId));

    if (!notification) return null;

    const notificationList = [
        {
            checked: notification.notifySetOrChangeLimits,
            label: tNotification.notifySetOrChangeLimits,
        },
        {
            checked: notification.notifyOverWarning,
            label: tNotification.notifyOverWarning,
        },
        {
            checked: notification.notifyOverBreak,
            label: tNotification.notifyOverBreak,
        },
        {
            checked: notification.notifyStartUseLimits,
            label: tNotification.notifyStartUseLimits,
        },
    ];

    return (
        <div className="subscriber-dc-rules__notification">
            <div className="subscriber-id__title subscriber-id__title_bold">
                {tNotification.title}
            </div>
            <div className="subscriber-dc-rules__notification-list">
                {
                    notificationList.map((notification, index) => (
                        <Checkbox
                            disabled
                            key={notification.label || index}
                            {...notification}
                        />
                    ))
                }
            </div>
        </div>
    );
};

export default SubscriberIdDcRuleNotifications;
